module.exports = __webpack_public_path__ + "asset/company-secretary-details-form--6e2511.png";